import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from './login.action';
import '~/stylesheets/login.page.scss';
import img from '~/assets/Logo_big.png';
import MDSpinner from "react-md-spinner";
import { bindActionCreators } from "redux";



// import '~/stylesheets/login.page.bg.scss';

import WindowAlert from '../common/AlertComponent';

class LoginPage extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
            status: false,
            isSuccess: false,
            isNew: false,
            errmsg: '',
            messageType: 'HULU',
            message: 'Dummy Messages, to sent',
            rememberMe: 0,
            userType: null,
            showSpinner: false,
        }
        //bg_color_fix
        if (window.location.pathname === "/login") {
            document.body.className = "fix_bg";
        }
    }

    handleChange = (e) => {
        if (e.target.name === 'rememberMe') {
            this.setState({ [e.target.name]: e.target.checked ? 1 : 0 });
        } else {
            this.setState({ [e.target.name]: e.target.value });
        }
        
    }

    handleLogin = () => {
        this.setState({showSpinner:true})
        this.props.login(this.state)
        .then( (res) => {
            if(res.data.status === 'success') {
                console.log("token after login",res.data.token)
                localStorage.setItem('authToken', res.data.token);
                localStorage.setItem('userType', res.data.userType);
                localStorage.setItem('userID', res.data.user_id)
                if (res.data.is_new) {
                    localStorage.setItem('is_new', 1);
                } else {
                    localStorage.removeItem('is_new');
                    
                }
                this.setState({
                    status: true,
                    isSuccess: true,
                    isNew: res.data.is_new ? true : false,
                    message: res.data.message,
                    messageType: res.data.status,
                    userType: res.data.userType,
                    showSpinner:false,
                });
                window.location.reload(); // to remove redux store content from previous user + update api url const for demo api
            } else {
                this.setState({
                    status: true,
                    message: res.data.message,
                    messageType: res.data.status,
                    showSpinner:false,
                });
            }
        })
        .catch( (err) => {
            this.setState({
                status: true,
                message: "Something went wrong, Please check your network connection",
                messageType: "Error",
                showSpinner:false,
            });
        })
    }


    handleAlert = () => {
        this.setState({ status: this.state.status ? false : true })
    }

    render () {

        if (this.state.isSuccess && localStorage.getItem('authToken') !== null) {
           //if (this.state.isSuccess) {
            if (this.state.isNew && this.state.userType === 1){
                return (
                    <Redirect to={{ pathname: "/viewBoarding", state: { 
                        userType: this.state.userType,
                        is_new: 1
                 } }} />
                );
            } else {
                document.body.className = "fix_bgs";       
                return (
                    <Redirect to="/" />
                );
            }
        }


        return (
            <div className="container-fluid login_page_wrapper">
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                        <div className="header_img_logo">
                            <img src={img} alt="Kinetic Logo"/>
                        </div>

                        <WindowAlert 
                            show={this.state.status}
                            messageType={this.state.messageType}
                            text={this.state.message}
                            onCofirm={this.handleAlert}
                            onCancel={this.handleAlert}
                        />
                        <div className="login_form">
                            <h3>Login to your account</h3>
                            <input onChange={this.handleChange} type="email" id="email" name="email" placeholder="Email"/> <br />
                            <input onChange={this.handleChange} type="password" id="password" name="password" placeholder="Password"/> <br />
                            
                            <div className="keep_me_signed_in">
                                <input onChange={this.handleChange} name="rememberMe" type="checkbox"/>
                                <span>Keep me signed in</span>
                            </div> <br />
                            <input onClick={this.handleLogin} type="submit" id="submit_box" value="Login"/>
                            <p>{this.state.showSpinner&&<MDSpinner className="login-spinner"/>}</p>
                        </div>
                        <div className="forgot_pw_area">
                            {/* <a href="" alt="forget your password by clicking here" ></a> */}
                            <Link to="/forgotPassword"> Forgot Password? </Link>
                        </div>

                        <div className="login_page_footer">
                            {/* <h3><a href="">Sign up for an account</a></h3> */}
                            <ul className="footer_login_links">
                                <li><a href="">Terms of use</a></li>
                                <li><a href="">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
      
    };
  };
  
  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        login,
      },
      dispatch
    );
  }

export default connect(mapStateToProps,mapDispatchToProps)(LoginPage);


// WEBPACK FOOTER //
// ./src/app/login_page/LoginPage.js